import { Eye } from "lucide-react";
import type { SourceDocument } from "@/types/tax";
import { Badge } from "@/components/ui/Badge";
import { Button } from "@/components/ui/Button";

export function SourceControl({
  source,
  document,
  expanded,
  onToggle,
}: {
  source: "manual" | "document_scan";
  document?: SourceDocument | null;
  expanded?: boolean;
  onToggle?: () => void;
}) {
  if (source === "document_scan") {
    if (document?.storagePath && !document.pdfRemovedAt && onToggle) {
      return (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="min-h-9 px-2"
          aria-expanded={expanded}
          onClick={onToggle}
        >
          <Eye className="size-4" aria-hidden="true" />
          Scanned source
        </Button>
      );
    }
    return <Badge variant="outline">Source unavailable</Badge>;
  }

  return <Badge variant="muted">Manual</Badge>;
}
